import { FileUsageComponent, flattenUsage, groupUsage } from 'components/FileUsage'
import Button from 'components/uiKit/Button'
import Card from 'components/uiKit/Card'
import Loader from 'components/uiKit/Loader'
import Modal, { MCWithParams, ModalBody, ModalFooter, ModalHeader } from 'components/uiKit/Modal'
import { FileComponent } from 'components/uiKit/Table'
import { FileMetaFor } from 'gql/__generated__/graphql'
import { useFileMetasWithUsagesGetByIds } from 'gql/files/apollo'
import { t } from 'services/Translation'
import { FinderFileItem } from 'store/models'
import { prepareFinderItem } from 'utils/useFinder'

import * as s from './FileDeleteModal.module.scss'

export interface IFileDeleteModalProps {
  fileIds?: string[]
  groupIds?: string[]
  companyId: string
  projectId?: string
  createFor?: FileMetaFor.companies | FileMetaFor.projects
}

const FileDeleteModal: MCWithParams<IFileDeleteModalProps, string[] | undefined> = ({
  onClose,
  params,
}) => {
  const { fileIds, companyId, projectId, groupIds, createFor = FileMetaFor.companies } = params
  const { files, loading, error } = useFileMetasWithUsagesGetByIds(
    companyId,
    projectId,
    fileIds,
    groupIds,
    createFor,
  )
  const showBorder = files.some((file) => file.fileUsage.length > 0)
  const count = files.filter((file) => file.fileUsage.length > 0).length

  return (
    <Modal name='fileDeleteModal' onClose={onClose}>
      <ModalHeader
        description={
          <>
            {t('modal.delete.description')}
            <br />
            {count > 0 ? t('modal.deleteFile.description', { count }) : null}
          </>
        }
        title={t('modal.delete.title')}
      />
      <ModalBody sizeAutoCapable>
        {loading && <Loader name='fileDeleteLoader' />}
        {files.map((file) => {
          const groupedUsages = groupUsage(file.fileUsage, companyId)

          if (groupedUsages.length === 0) {
            return null
          }

          return (
            <>
              {file.fileUsage.length > 0 && (
                <div className={s.fileItem} key={file.id}>
                  <FileComponent
                    file={{ ...prepareFinderItem(file, ''), ...file } as FinderFileItem}
                    gap={8}
                  />
                </div>
              )}
              <div className={s.fileUsage}>
                {groupedUsages.map((groupedUsage) => (
                  <Card
                    hovered={false}
                    key={groupedUsage.projectId}
                    name={`fileUsageCard-${file.id}`}
                    padding={32}
                  >
                    {flattenUsage(groupedUsage).map((usage) => (
                      <FileUsageComponent key={usage.blockName} usage={usage} />
                    ))}
                  </Card>
                ))}
              </div>
            </>
          )
        })}
      </ModalBody>
      <ModalFooter bordered={showBorder}>
        <Button name='cancel' onClick={() => onClose()} styleType='ghost'>
          {t('uiKit.button.cancel')}
        </Button>
        <Button
          disabled={loading || !!error}
          name='confirm'
          onClick={() => onClose(files.map((file) => file.id))}
        >
          {t('uiKit.button.delete')}
        </Button>
      </ModalFooter>
    </Modal>
  )
}

export default FileDeleteModal
